import React, { useState, useEffect, useRef } from 'react';
import tangangenggam from '../components/img/genggam.png';
import tanganregang from '../components/img/tangan.png';
import dropsound from './music/drop.mp3';

const ButtonThrow = ({ show, onClick, isSeedThrown }) => {
    const [visible, setVisible] = useState(show);
    const dropSoundRef = useRef(new Audio(dropsound)); 

    useEffect(() => {
        if (isSeedThrown) {
            const timer = setTimeout(() => {
                setVisible(false);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setVisible(show);
        }
    }, [isSeedThrown, show]);

    const handleClick = (e) => {
        dropSoundRef.current.play(); // Memainkan sound effect saat tombol diklik
        onClick(e); // Memanggil fungsi onClick yang diberikan sebagai prop
    };

    if (!visible) return null;

    return (
        <button
            onClick={handleClick}
            className="flex items-center justify-center bg-transparent rounded absolute tanganbutton"
        >
            <img 
                src={isSeedThrown ? tanganregang : tangangenggam} 
                alt={isSeedThrown ? "Tangan Regang" : "Tangan Genggam"} 
                className="transition-img lg:w-48 lg:h-48 sm:w-24 sm:h-24 md:w-32 md:h-32 object-contain lg:mt-80 md:mt-48 sm:mt-32" 
            />
        </button>
    );
};

export default ButtonThrow;
